import React from 'react';
import { Checkbox, Form } from 'antd';
import { apiMessagesGetFormRules } from '../../middleware';
import { upperCaseFirstLetter } from '../../instruments';
import { formatDataTestAttribute } from '../../instruments/testing';
import { tF } from '../../translate';
import { Catcher } from '../Catcher';
import Styles from '../styles/m_itemCardStyles.less';

type IFormMultiCheckboxFeaturesFields = {
    children?: never;
    dataTest?: string;
};

export const FormMultiCheckboxFeaturesFields: React.FC<IFormMultiCheckboxFeaturesFields> = ({
    dataTest = '',
}: IFormMultiCheckboxFeaturesFields) => {
    return (
        <Catcher>
            <div className={Styles.multiCheckboxField}>
                <div
                    data-test={formatDataTestAttribute(dataTest, 'FormMultiCheckboxFeaturesFields', 'Title')}
                    className={Styles.title}
                >
                    {tF('Features')}:
                </div>
                <div className={Styles.values}>
                    <Form.Item
                        name={['features', 'data', 'enabled']}
                        key={'data'}
                        className={Styles.value}
                        rules={apiMessagesGetFormRules}
                        valuePropName="checked"
                    >
                        <Checkbox>{upperCaseFirstLetter('data')}</Checkbox>
                    </Form.Item>
                    <Form.Item
                        name={['features', 'sms', 'enabled']}
                        key={'sms'}
                        className={Styles.value}
                        rules={apiMessagesGetFormRules}
                        valuePropName="checked"
                    >
                        <Checkbox>{upperCaseFirstLetter('sms')}</Checkbox>
                    </Form.Item>
                    <Form.Item
                        name={['features', 'voice', 'enabled']}
                        key={'voice'}
                        className={Styles.value}
                        rules={apiMessagesGetFormRules}
                        valuePropName="checked"
                    >
                        <Checkbox>{upperCaseFirstLetter('voice')}</Checkbox>
                    </Form.Item>
                </div>
            </div>
        </Catcher>
    );
};
